import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';

import {initNavbarState} from 'actions/navbar.js';

import {colors, fontSizes, fonts} from 'style';

import ActivitiesContainer from 'modules/newsfeed/ActivitiesContainer.js';

class MyProgressContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {activities:[]};
    }

    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, mode:'main', menuEnable:true, backButtonEnable:false, rewardsEnable:true}));
    }

    render() {
        return <ActivitiesContainer feedMethod='getMyProgressFeed' pageTitle={this.props.t('My Progress')} />;
    }

}


export default withRouter(connect()(translate('newsfeed')(MyProgressContainer)));



// WEBPACK FOOTER //
// ./src/modules/newsfeed/MyProgressContainer.js